import { Appointment } from '../types/booking';
import { AppointmentResponse } from '../types/rest';

export const formatAppointmentResponse = (data: AppointmentResponse): Appointment => {
	return {
		attendees: data.attendees,
		bookingBusinessId: data.business_id,
		bookingBusinessName: data.business_name,
		endDatetime: data.end_datetime,
		hostEmail: data.host_email,
		hostImageUrl: data.host_image_url,
		hostName: data.host_name,
		id: data.id,
		joinWebUrl: data.join_web_url,
		manageBookingUrl: data.manage_booking_url,
		bookingServiceId: data.service_id,
		bookingServiceName: data.service_name,
		staffId: data.staff_id,
		startDatetime: data.start_datetime,
	};
};
